module.exports = __webpack_public_path__ + "img/radio-active.svg";